import {deviceList} from '@/api/participant';
import { logError } from "@/utils/appLogger";

const callGetDevices = (context) => {
    deviceList().then(({data, status}) => {
        if (status === 200) {
            context.commit('setDevices', data);
        } else {
            logError('Something wrong with devices');
        }
    })
}

export default {
    callGetDevices,
}
